import { lazy, Suspense } from "react";
import AppShell from "./AppShell";

const AccessoryCatalog = lazy(async () => ({ default: (await import("./pages/HardwareCatalog")).HardwareHub }));
const HardwareCategoryPage = lazy(async () => ({ default: (await import("./pages/HardwareCatalog")).HardwareCategoryPage }));
const HardwareProductPage = lazy(async () => ({ default: (await import("./pages/HardwareCatalog")).HardwareProductPage }));

export default function AppClient() {
  return (
    <Suspense fallback={<main className="section-line" aria-live="polite"><p>Loading accessory catalog…</p></main>}>
      <AppShell AccessoryCatalog={AccessoryCatalog} HardwareCategoryPage={HardwareCategoryPage} HardwareProductPage={HardwareProductPage} />
    </Suspense>
  );
}
